export function emitAvatarSoundSourceSet(el, soundSource) {
  el.emit("sound-source-set", { soundSource }, true);
}
